import { createSlice } from "@reduxjs/toolkit";
import { IMasterState } from "./types";

const initialState: IMasterState = {
  rfqList: null,
  quoteDetails: null,
  rfqRoundsList: null,
  coverageTypeList: null,
  coverageTypeOptions: [],
  layerList: [],
};

const rfqSlice = createSlice({
  name: "rfqSlice",
  initialState,
  reducers: {
    setRFQList: (state, action) => {
      const payload = action.payload;

      if (payload?.result) {
        state.rfqList = payload.result;
        return;
      }

      if (Array.isArray(payload?.data)) {
        state.rfqList = {
          data: payload.data,
          total: payload.total ?? payload.count ?? payload.data.length,
        };
        return;
      }

      if (Array.isArray(payload?.results)) {
        state.rfqList = {
          data: payload.results,
          total: payload.total ?? payload.count ?? payload.results.length,
        };
        return;
      }

      if (Array.isArray(payload)) {
        state.rfqList = {
          data: payload,
          total: payload.length,
        };
        return;
      }

      state.rfqList = null;
    },
    setQuoteDetails: (state, action) => {
      state.quoteDetails = action.payload;
    },
    setRFQRoundsList: (state, action) => {
      state.rfqRoundsList = action.payload;
    },
    setCoverageTypeList: (state, action) => {
      state.coverageTypeList = action.payload?.result;
      state.coverageTypeOptions =
        action.payload?.result?.map((item: any) => ({
          value: item.id,
          label: item.name,
        })) || [];
    },
    setLayerList: (state, action) => {
      state.layerList = action.payload;
    },
    AddLayer: (state, action) => {
      if (state.layerList) {
        state.layerList.push({ quote_layer: action.payload });
      } else {
        state.layerList = [action.payload];
      }
    },
    AddInsurerToLayer: (state, action) => {
      const rfqs = action.payload || [];

      console.log("AddInsurerToLayer payload:", rfqs);
      console.log("Current layerList:", state.layerList);

      if (!Array.isArray(rfqs) || rfqs.length === 0) {
        console.log("No RFQs received");
        return;
      }

      const layerId = rfqs[0]?.quote_layer_id;

      const layer = state.layerList?.find(
        (item) => String(item.quote_layer?.id) === String(layerId)
      );
      console.log("Looking for layer:", layerId, layer);

      if (!layer) {
        console.log("Layer not found:", layerId);
        return;
      }

      if (!layer.rfqs) {
        layer.rfqs = [];
      }

      rfqs.forEach((rfq) => {
        const existingIndex = layer.rfqs.findIndex((item) => item.id === rfq.id);

        if (existingIndex === -1) {
          layer.rfqs.push(rfq);
        } else {
          layer.rfqs[existingIndex] = rfq;
        }
      });
    },
  },
});

export const {
  setRFQList,
  setQuoteDetails,
  setRFQRoundsList,
  setCoverageTypeList,
  setLayerList,
  AddLayer,
  AddInsurerToLayer,
} = rfqSlice.actions;
export default rfqSlice.reducer;
